import { OverviewItem } from './OverviewItem';

interface OverviewCommentsItemProps {
  commentsCount: number;
}

export const OverviewCommentsItem = ({
  commentsCount,
}: OverviewCommentsItemProps) => {
  const label = `${commentsCount || 'No'} comments`;
  const buttonLabel = 'View comments';
  const iconName = 'ChatBubble';
  const section = 'comments-section';
  const containerProps = {
    containerProps: { 'data-cy': 'overview-comments-item' },
  };
  return (
    <OverviewItem
      label={label}
      iconName={iconName}
      buttonLabel={buttonLabel}
      section={section}
      otherProps={containerProps}
    />
  );
};
